export const UserTagType = 'User'
export const AllUsers = { type: 'User' as const, id: 'All' }
